import React, { useState, useEffect, useRef } from 'react';

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import {
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    FormHelperText
} from '@mui/material';

import "../../assets/css/Careers.css";
import logo from "../../assets/images/logo/dodeal-white.png";

function Marketing() {
    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 4;

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        age: '',
        languages: ['English'],
        otherLang: '',
        position: '',
        experience: '',
        availability: '',
        expectedSalary: '',
        cv: null,
    });

    const [errors, setErrors] = useState({
        nameError: '',
        phoneError: '',
        emailError: '',
        ageError: '',
        languageError: '',
        positionError: '',
        experienceError: '',
        availabilityError: '',
        expectedError: '',
        cvError: ''
    });

    const handleNext = () => {
        if (validateFields()) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handlePrevious = () => {
        setCurrentStep(currentStep - 1);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateFields()) {
            // Form submission logic
            alert('Form submitted');
        }
    };

    // const phoneInputRef = useRef(null);

    // const handlePhoneChange = (status, value, countryData) => {
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         phone: value,
    //     }));

    //     const isValid = status === "valid";

    //     // VALIDATION
    //     if (!isValid) {
    //         setErrors((prevErrors) => ({
    //             ...prevErrors,
    //             phoneError: "Please enter a valid phone number.",
    //         }));
    //     } else {
    //         setErrors((prevErrors) => ({
    //             ...prevErrors,
    //             phoneError: "",
    //         }));
    //     }
    // };

    const validateFields = () => {
        let valid = true;
        let newErrors = {};

        // Step 1 Validation
        if (currentStep === 1) {
            if (!formData.name.trim()) {
                newErrors.nameError = 'Please enter your full name.';
                valid = false;
            } else {
                newErrors.nameError = '';
            }

            if (!formData.phone.trim()) {
                newErrors.phoneError = 'Please enter a valid contact number.';
                valid = false;
            } else {
                newErrors.phoneError = '';
            }

            if (!validateEmail(formData.email)) {
                newErrors.emailError = 'Please enter a valid email address.';
                valid = false;
            } else {
                newErrors.emailError = '';
            }

            if (formData.age < 18 || formData.age > 80) {
                newErrors.ageError = 'Please enter a valid age (18-80).';
                valid = false;
            } else {
                newErrors.ageError = '';
            }
        }

        // Step 3 Validation
        if (currentStep === 3) {
            if (!formData.language.length) {
                newErrors.languageError = 'Select at least one language.';
                valid = false;
            } else {
                newErrors.languageError = '';
            }
        }

        // Step 4 Validation
        if (currentStep === 4) {
            if (!formData.position || !formData.experience || !formData.availability || !formData.expected) {
                newErrors.positionError = 'Please fill out all the fields in this step.';
                valid = false;
            } else {
                newErrors.positionError = '';
                newErrors.experienceError = '';
                newErrors.availabilityError = '';
                newErrors.expectedError = '';
            }
        }

        // Step 5 Validation
        if (currentStep === 5) {
            if (!formData.cv) {
                newErrors.cvError = 'Please upload your CV.';
                valid = false;
            } else {
                newErrors.cvError = '';
            }
        }

        setErrors(newErrors);
        return valid;
    };

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    return (
        <>
            {/* D SHAPED DESIGN  */}
            <div
                className="fixed top-5 bg-white rounded-full w-[300px] h-[300px] right-[-150px] md:w-[400px] md:h-[400px] md:right-[-200px] lg:w-[500px] lg:h-[500px] lg:right-[-250px]"
                style={{
                    zIndex: -2
                }}
            ></div>
            {/* HEADING */}
            <div className="first_section px-10 my-5">
                <img
                    src={logo}
                    className="logo-img w-[100px] h-auto object-contain mb-5"
                    alt="DoDeal Careers | Hiring Application | Marketing | IT | Real Estate"
                />
                <div className="flex justify-end my-5">
                    <div className="primary-text font-bold uppercase text-3xl md:text-4xl lg:text-5xl xl:text-6xl mt-5 text-end w-[350px] md:w-[550px] lg:w-[750px] xl:w-[950px]">
                        Exciting Marketing Opportunities at DoDeal
                    </div>
                </div>
                <div className="primary-shadow-text py-5 w-[300px] md:w-[500px] lg:w-[750px] xl:w-[950px] font-normal">
                    {/*  */}
                    <div className="primary-shadow-text lg:hidden">
                        Are you a creative marketing professional?
                        <br />
                        Join our growing team in Egypt to craft impactful campaigns, manage digital media, and drive brand success.
                        Let’s shape the future together!
                    </div>
                    <div className="primary-shadow-text hidden lg:flex">
                        Are you a results-driven marketing professional with a flair for strategy and creativity?
                        <br />
                        We are seeking talented individuals to join our dynamic marketing team in Egypt. Whether you excel in crafting impactful campaigns, managing digital media, or driving brand visibility, we have exciting opportunities waiting for you. Shape the future of marketing with us and leave your mark on a growing industry.
                    </div>
                </div>
            </div>
            <div className="second_section px-10 my-5 py-5">
                {/* Progress Bar */}
                <ul id="progressbar" className="p-0">
                    {Array.from({ length: 4 }, (_, i) => (
                        <li
                            key={i + 1}
                            id={`step${i + 1}`}
                            className={i + 1 <= currentStep ? "active" : ""}
                        ></li>
                    ))}
                </ul>
                <div class="flex justify-center items-center">
                    {/* Form */}
                    <form id="hiring-form" onSubmit={handleSubmit}>
                        <div className="fieldset my-3" style={{ display: currentStep === 1 ? 'block' : 'none' }}>
                            <div className="form-card p-4">
                                <div className="flex flex-col justify-center items-center gap-2 w-full">
                                    {/* NAME */}
                                    <div className="w-full">
                                        <label className="mt-0">Full name <span className="text-danger">*</span></label>
                                        {/* <input
                                            type="text"
                                            name="name"
                                            id="name"
                                            placeholder="Your full name"
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            required
                                        />
                                        <small className="text-danger">{errors.nameError}</small> */}
                                        <TextField
                                            placeholder="Your full name"
                                            variant="outlined"
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            required
                                            fullWidth
                                            error={!!errors.nameError}
                                            helperText={errors.nameError}
                                        />
                                    </div>
                                    {/* CONTACT */}
                                    <div className="w-full">
                                        <label>Contact number <span className="text-danger">*</span></label>
                                        {/* <input
                                            type="tel"
                                            name="phone"
                                            id="phone"
                                            placeholder="** *** ****"
                                            value={formData.phone}
                                            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                            required
                                        />
                                        <small className="text-danger">{errors.phoneError}</small> */}
                                        {/* <IntlTelInput
                                            ref={phoneInputRef}
                                            containerClassName="intl-tel-input"
                                            preferredCountries={['eg', 'ae']}
                                            separateDialCode
                                            value={formData.phone}
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            // onChange={() => { }}
                                            onPhoneNumberChange={(status, value, countryData) =>
                                                handlePhoneChange(status, value, countryData)
                                            }
                                            required
                                            fullWidth
                                            error={!!errors.phoneError}
                                            helperText={errors.phoneError}
                                        /> */}
                                    </div>
                                    {/* EMAIL */}
                                    <div className="w-full">
                                        <label>Email address <span className="text-danger">*</span></label>
                                        {/* <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            placeholder="Your email"
                                            value={formData.email}
                                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                            required
                                        />
                                        <small className="text-danger">{errors.emailError}</small> */}
                                        <TextField
                                            placeholder="Your email address"
                                            variant="outlined"
                                            type="email"
                                            value={formData.email}
                                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                            required
                                            fullWidth
                                            error={!!errors.emailError}
                                            helperText={errors.emailError}
                                        />
                                    </div>
                                    {/* AGE */}
                                    <div className="w-full">
                                        <label>Age (in years) <span className="text-danger">*</span></label>
                                        {/* <input
                                            type="number"
                                            name="age"
                                            id="age"
                                            placeholder="Your age in years"
                                            value={formData.age}
                                            onChange={(e) => setFormData({ ...formData, age: e.target.value })}
                                            min="18"
                                            max="60"
                                            required
                                        />
                                        <small className="text-danger">{errors.ageError}</small> */}
                                        <TextField
                                            placeholder="Your age in years"
                                            variant="outlined"
                                            type="number"
                                            value={formData.age}
                                            onChange={(e) => setFormData({ ...formData, age: e.target.value })}
                                            required
                                            fullWidth
                                            error={!!errors.ageError}
                                            helperText={errors.ageError}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-between items-center my-3">
                                <div className="justify-start"></div>
                                <div></div>
                                <div className="justify-end">
                                    <button type="button" className="next action-button" onClick={handleNext}>
                                        NEXT
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="fieldset my-3" style={{ display: currentStep === 2 ? 'block' : 'none' }}>
                            <div className="form-card p-4">
                                <div className="flex flex-col justify-center items-center gap-2 w-full">
                                    <div className="w-full">
                                        <label>Languages spoken <span className="text-danger">*</span></label>
                                        <select
                                            name="language"
                                            id="language"
                                            multiple
                                            value={formData.language}
                                            onChange={(e) => setFormData({ ...formData, language: Array.from(e.target.selectedOptions, option => option.value) })}
                                        >
                                            <option value="English">English</option>
                                            <option value="Arabic">Arabic</option>
                                            <option value="Nepali">Nepali</option>
                                            <option value="Hindi">Hindi</option>
                                        </select>
                                        <small className="text-danger">{errors.languageError}</small>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="otherLang"
                                            id="otherLang"
                                            placeholder="Additional language"
                                            value={formData.otherLang}
                                            onChange={(e) => setFormData({ ...formData, otherLang: e.target.value })}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row my-3">
                                <div className="col-4 justify-start">
                                    <button type="button" className="previous action-button-previous" onClick={handlePrevious}>
                                        PREV
                                    </button>
                                </div>
                                <div className="col-4"></div>
                                <div className="col-4 justify-end">
                                    <button type="button" className="next action-button" onClick={handleNext}>
                                        NEXT
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="fieldset my-3" style={{ display: currentStep === 3 ? 'block' : 'none' }}>
                            <div className="form-card p-4">
                                <div className="flex flex-col justify-center items-center gap-2 w-full">
                                    {/* POSITION */}
                                    <div className="w-full">
                                        <label>Position applying for <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            name="position"
                                            id="position"
                                            placeholder="Job position"
                                            value={formData.position}
                                            onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                                            required
                                        />
                                        <small className="text-danger">{errors.positionError}</small>
                                    </div>
                                    {/* EXPERIENCE */}
                                    <div className="w-full">
                                        <label>Experience <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            name="experience"
                                            id="experience"
                                            placeholder="Your work experience"
                                            value={formData.experience}
                                            onChange={(e) => setFormData({ ...formData, experience: e.target.value })}
                                            required
                                        />
                                        <small className="text-danger">{errors.experienceError}</small>
                                    </div>
                                    {/* AVAILABILITY */}
                                    <div className="w-full">
                                        <label>Availability <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            name="availability"
                                            id="availability"
                                            placeholder="Available start date"
                                            value={formData.availability}
                                            onChange={(e) => setFormData({ ...formData, availability: e.target.value })}
                                            required
                                        />
                                        <small className="text-danger">{errors.availabilityError}</small>
                                    </div>
                                    {/* EXPECTED SALARY */}
                                    <div className="w-full">
                                        <label>Expected salary <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            name="expected"
                                            id="expected"
                                            placeholder="Expected salary"
                                            value={formData.expected}
                                            onChange={(e) => setFormData({ ...formData, expected: e.target.value })}
                                            required
                                        />
                                        <small className="text-danger">{errors.expectedError}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="row my-3">
                                <div className="col-4 justify-start">
                                    <button type="button" className="previous action-button-previous" onClick={handlePrevious}>
                                        PREV
                                    </button>
                                </div>
                                <div className="col-4"></div>
                                <div className="col-4 justify-end">
                                    <button type="button" className="next action-button" onClick={handleNext}>
                                        NEXT
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="fieldset my-3" style={{ display: currentStep === 4 ? 'block' : 'none' }}>
                            <div className="form-card p-4">
                                <div className="flex flex-col justify-center items-center gap-2 w-full">
                                    <div className="w-full">
                                        <label>Upload CV <span className="text-danger">*</span></label>
                                        <input
                                            type="file"
                                            name="cv"
                                            id="cv"
                                            accept=".pdf"
                                            onChange={(e) => setFormData({ ...formData, cv: e.target.files[0] })}
                                            required
                                        />
                                        <small className="text-danger">{errors.cvError}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="row my-3">
                                <div className="col-4 justify-start">
                                    <button type="button" className="previous action-button-previous" onClick={handlePrevious}>
                                        PREV
                                    </button>
                                </div>
                                <div className="col-4"></div>
                                <div className="col-4 justify-end">
                                    <button type="submit" className="next action-button">
                                        SUBMIT
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div >
        </>
    );
}

export default Marketing;
